import { render, staticRenderFns } from "./CoDropdownItem.vue?vue&type=template&id=d6d67df8&scoped=true&"
import script from "./CoDropdownItem.vue?vue&type=script&lang=ts&"
export * from "./CoDropdownItem.vue?vue&type=script&lang=ts&"
import style0 from "./CoDropdownItem.vue?vue&type=style&index=0&id=d6d67df8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d67df8",
  null
  
)

export default component.exports